(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4437],{

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 67533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12755);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_responsive_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10615);
/* harmony import */ var _data_StaticList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47027);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);






const Features = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
        sx: {
            minHeight: {
                xs: "70vh",
                md: "100vh"
            },
            display: {
                xs: "flex",
                md: "none"
            }
        },
        style: {
            width: "100vw",
            justifyContent: "center",
            alignItems: "center",
            padding: "48px 24px",
            top: "0",
            position: "relative",
            background: "white"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                sx: {
                    display: {
                        xs: "block",
                        md: "flex"
                    },
                    width: {
                        xs: "100%",
                        md: "90%"
                    }
                },
                style: {
                    height: "90%",
                    margin: "auto",
                    flexWrap: "wrap",
                    padding: "2%",
                    justifyContent: "space-around",
                    alignItems: "center",
                    overflowY: "scroll"
                },
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        sx: {
                            width: {
                                xs: "100%",
                                md: "55%"
                            }
                        },
                        style: {
                            height: "100%",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            sx: {
                                fontSize: {
                                    xs: "24px",
                                    md: "40px"
                                },
                                textAlign: {
                                    xs: "center",
                                    md: "left"
                                },
                                fontWeight: "700"
                            },
                            children: "Unlock extra income for all your needs"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        sx: {
                            width: {
                                xs: "100%",
                                md: "40%"
                            },
                            margin: "auto"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_2__/* .Carousel */ .lr, {
                            autoPlay: true,
                            interval: 4000,
                            infiniteLoop: true,
                            showStatus: false,
                            showThumbs: false,
                            swipeable: false,
                            children: _data_StaticList__WEBPACK_IMPORTED_MODULE_3__/* .FEATURE_LIST.map */ .ql.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    sx: {
                                        display: {
                                            xs: "flex",
                                            md: "none"
                                        },
                                        minHeight: "380px",
                                        width: "250px",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        padding: "8px",
                                        margin: {
                                            xs: "auto",
                                            md: "0px 15px"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                            container: true,
                                            sx: {
                                                height: "200px",
                                                width: "100%",
                                                justifyContent: "center"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                src: item.staticIcon,
                                                alt: item.alt,
                                                style: {
                                                    objectFit: "contain"
                                                },
                                                loading: "lazy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    variant: "body2",
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    children: item.content
                                                })
                                            ]
                                        })
                                    ]
                                }, i))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                sx: {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    display: {
                        xs: "none",
                        md: "block"
                    },
                    height: {
                        xs: "150px",
                        md: "215px"
                    },
                    width: {
                        xs: "200px",
                        md: "300px"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 300 215",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            opacity: "0.05",
                            cx: "57",
                            cy: "-28",
                            r: "193",
                            stroke: "url(#paint0_linear_29650_4192)",
                            strokeWidth: "100"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                id: "paint0_linear_29650_4192",
                                x1: "117.5",
                                y1: "21.5",
                                x2: "300",
                                y2: "183.887",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#28BE35"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#5377D7"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Features);


/***/ })

}]);